import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import './ProjectDetailsPage.css';
import Navbar from '../Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ParticlesBackground from '../../components/ParticleBackground/ParticleBackground';
import { AnimatePresence, motion } from 'framer-motion';
import $ from 'jquery';

const ProjectDetailsPage = () => {
  const { slug } = useParams(); // Get the slug from URL params
  const [selectedImage, setSelectedImage] = useState(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const videoRef = useRef(null);
  const headerRef = useRef(null);
  const infoRef = useRef(null);
  const descriptionRef = useRef(null);
  const galleryRef = useRef(null);
  const galleryItemsRef = useRef([]);
  const promoRef = useRef(null);
  const blobsRef = useRef([]);
  const carouselRef = useRef(null);
  
  // Add state for tracking the real position (can go beyond array bounds)
  const [realIndex, setRealIndex] = useState(0);
  
  // Add these new refs and state
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState(0);
  const [dragEnd, setDragEnd] = useState(0);
  const slideWidth = 500; // Width of each slide
  
  // Sample projects data - in a real app, this would come from an API call
  const projects = [
    {
      id: 1,
      title: "DGE Cyber Security Week 2025",
      slug: "dge-cyber-security-week",
      date: "12th - 17th January, 2025",
      client: "DGE",
      category: "Cyber Security",
      tags: ["Cyber Security", "Interactive", "UX/UI"],
      description: `
        This interactive and immersive event was designed to engage employees and raise awareness about cyber security through a week-long series of creative activations. At its core was the Web Game Challenge, where a new cyber security-themed game was unlocked daily, leading to a live leaderboard competition. The top 20 participants advanced to a final Trivia Game Showdown.
      `,
      videoThumbnail: require('../../asset/Viola/banner.jpg'), // Using existing banner as thumbnail for now
      mainImage: require('../../asset/Viola/banner.jpg'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/Viola/Headphone-Wall.jpeg'),
          caption: "Headphone Wall - Interactive audio experience for cyber security education"
        },
        {
          id: 2,
          image: require('../../asset/Viola/Claw-Machine.jpeg'),
          caption: "Claw Machine - Gamified giveaway experience"
        },
        {
          id: 3,
          image: require('../../asset/Viola/Magnetic-Mosaic -Wall.jpeg'),
          caption: "Magnetic Mosaic Wall - Collaborative security-themed installation"
        },
        {
          id: 4,
          image: require('../../asset/Viola/Robo-Cafe.jpeg'),
          caption: "Robo Café - Robotic arm serving coffee, merging tech and hospitality"
        }
      ]
    },
    {
      id: 2,
      title: "ADQ Carnival 2025",
      slug: "adq-carnival",
      date: "2024",
      client: "ADQ",
      category: "Corporate Event",
      tags: ["Corporate", "Entertainment", "Activation"],
      description: `
        A vibrant corporate carnival event designed to bring together employees and stakeholders in a fun, engaging environment. The ADQ Carnival featured multiple interactive zones, entertainment activities, and team-building experiences that reinforced company culture while providing memorable experiences for all attendees.
      `,
      videoThumbnail: require('../../asset/ADQ Carnival/1.JPG'),
      videoUrl: "https://www.youtube.com/embed/1JxfOk5j4Oc?si=pCiaVvyi6-bG9z7C",
      mainImage: require('../../asset/ADQ Carnival/1.JPG'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/ADQ Carnival/1.JPG'),
          caption: "Runner Game"
        },
        {
          id: 2,
          image: require('../../asset/ADQ Carnival/2.JPG'),
          caption: "Buzz Wire"
        },
        {
          id: 3,
          image: require('../../asset/ADQ Carnival/3.JPG'),
          caption: "Catch the Stick - Reflex Game"
        },
        {
          id: 4,
          image: require('../../asset/ADQ Carnival/4.JPG'),
          caption: "Ball Blower Booth"
        }
      ]
    },
    {
      id: 3,
      title: "Comex Oman 2024",
      slug: "comex-oman",
      date: "2024",
      client: "Comex Oman",
      category: "Trade Exhibition",
      tags: ["Exhibition", "Trade Show", "Networking", "B2B"],
      description: `
        To position Omantel as a tech-savvy leader in digital innovation, the brand delivered an immersive AI-driven experience showcasing the future of customer interaction and creativity.<br/><br/>
        
        The AI Chatbot Experience simulated intelligent, real-time customer support by answering service-related queries and guiding visitors with tailored responses, reflecting Omantel's vision for seamless telecom interactions. The Sketch to AI Station invited users to draw on tablets, which were then transformed by generative AI into vivid visuals, blending human creativity with machine learning.<br/><br/>
        
        Both activations attracted strong engagement, reinforcing Omantel's commitment to innovation and digital transformation.
      `,
      videoThumbnail: require('../../asset/Comex/1.jpg'),
      mainImage: require('../../asset/Comex/1.jpg'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/Comex/1.jpg'),
          caption: "Comex Oman exhibition booth and display setup"
        },
        {
          id: 2,
          image: require('../../asset/Comex/2.jpg'),
          caption: "Interactive demonstrations and business networking"
        },
        {
          id: 3,
          image: require('../../asset/Comex/3.jpg'),
          caption: "Interactive demonstrations and business networking"
        }
      ]
    },
    {
      id: 4,
      title: "DU GITEX Northstar 2025",
      slug: "du-gitex-northstar",
      date: "October 2025",
      client: "Du",
      category: "Technology Exhibition",
      tags: ["GITEX", "Innovation", "Technology", "Interactive"],
      description: `
        To showcase du's leadership in AI and future technologies, the brand created an immersive, innovation-led space filled with intelligent and interactive experiences.<br/><br/>
        
        Highlights included the AI Judge, which evaluated startup pitches live; the Apple Vision Pro Human vs AI challenge, blending mixed reality with cognitive comparison; a reflex-based interactive touch game that reinforced du's dynamic digital edge; and an AI hologram assistant that guided attendees through the space.<br/><br/>
        
        Each activation demonstrated du's commitment to next-gen engagement, sparking curiosity and reinforcing its role at the forefront of AI, XR, and digital innovation.
      `,
      videoThumbnail: require('../../asset/Northstar/1.jpg'),
      mainImage: require('../../asset/Northstar/1.jpg'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/Northstar/1.jpg'),
          caption: "Apple Vision Pro "
        },
        {
          id: 2,
          image: require('../../asset/Northstar/2.jpg'),
          caption: "AI Chatbot Judge"
        },
        {
          id: 3,
          image: require('../../asset/Northstar/3.jpg'),
          caption: "AI Hologram Chatbot"
        },
        {
          id: 4,
          image: require('../../asset/Northstar/4.jpg'),
          caption: "DU Northstar Stand"
        }
      ]
    },
    {
      id: 5,
      title: "NBA BRED Festival 2025",
      slug: "nba-bred-festival",
      date: "2025",
      client: "NBA",
      category: "Sports Activation",
      tags: ["Basketball", "Interactive", "LED Wall", "Festival"],
      description: `
        The objective was to engage festival attendees with dynamic basketball-themed interactive games that combined physical activity, reflex challenges, and arcade-style fun, closely tied to the NBA brand and culture.<br/><br/>
        
        Key activations included the Basketball Drop and Catch Reflex Game, featuring an NBA-branded structure releasing multiple basketballs sequentially for participants to catch, with a scoring system tracking successful catches, creating excitement and friendly competition while testing agility. The second activation was the Basketball Shoot Game on an LED Wall Screen, where players shot real basketballs at a large LED display showing dynamic score circles with positive and negative points, aiming to maximize their score.<br/><br/>
        
        Both games generated strong engagement, lively competition, and reinforced the NBA's energetic, active image throughout the festival.
      `,
      videoThumbnail: require('../../asset/NBA BRED/1.jpg'),
      mainImage: require('../../asset/NBA BRED/1.jpg'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/NBA BRED/1.jpg'),
          caption: "Basketball drop and catch reflex game activation"
        },
        {
          id: 2,
          image: require('../../asset/NBA BRED/2.jpg'),
          caption: "LED wall basketball shooting game"
        },
        {
          id: 3,
          image: require('../../asset/NBA BRED/3.jpg'),
          caption: "NBA branded interactive basketball zone"
        },
        {
          id: 4,
          image: require('../../asset/NBA BRED/4.jpg'),
          caption: "Festival attendees engaging with basketball activities"
        }
      ]
    },
    {
      id: 6,
      title: "Arab Health - American Hospital 2025",
      slug: "arab-health",
      date: "2025",
      client: "Arab Health",
      category: "Healthcare Exhibition",
      tags: ["Healthcare", "Exhibition", "Medical Technology"],
      description: `
        A comprehensive healthcare exhibition showcasing the latest medical technologies, innovations, and solutions. Our activation created an immersive experience that connected healthcare professionals with cutting-edge medical equipment and services, facilitating knowledge exchange and business networking in the healthcare sector.
      `,
      videoThumbnail: require('../../asset/Arab Health/1.JPEG'),
      mainImage: require('../../asset/Arab Health/1.JPEG'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/Arab Health/1.JPEG'),
          caption: "NFC Activation"
        },
        {
          id: 2,
          image: require('../../asset/Arab Health/2.JPEG'),
          caption: "Tangible Table - Hospital Services Portal"
        },
        {
          id: 3,
          image: require('../../asset/Arab Health/3.JPEG'),
          caption: "Longevity Vault - Health and Wellness Analysis"
        },
        {
          id: 4,
          image: require('../../asset/Arab Health/4.JPEG'),
          caption: "Hologram Display"
        },
        {
          id: 5,
          image: require('../../asset/Arab Health/5.JPEG'),
          caption: "Conference and seminar spaces"
        }
      ]
    },
    {
      id: 7,
      title: "Global Freight Summit - GPJ 2024",
      slug: "global-freight-summit",
      date: "2023",
      client: "GPJ",
      category: "Sports Simulation",
      tags: ["Cricket", "Interactive", "Leaderboard", "Competition"],
      description: `
        The objective was to deliver an energetic, culturally resonant experience that promoted competition and engagement, reflecting the excitement of sport and achievement within the logistics and freight industry.<br/><br/>
        
        The key activation was an Interactive Cricket Simulation with Live Leaderboard, featuring a branded batting zone where participants registered, entered a cricket net, and batted against auto-dispensed balls to hit wall-mounted targets with varying point values. Scores were tracked and displayed in real time on a digital leaderboard, while a registration system logged participant names and scores.<br/><br/>
        
        This activation attracted consistent crowds, fostered friendly competition, energized the event space, and enhanced GPJ's brand recall through immersive, memorable interaction.
      `,
      videoThumbnail: require('../../asset/GPJ/1.jpg'),
      videoUrl: "https://samplelib.com/lib/preview/mp4/sample-5s.mp4",
      mainImage: require('../../asset/GPJ/1.jpg'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/GPJ/1.jpg'),
          caption: "Interactive cricket simulation with live leaderboard"
        },
        {
          id: 2,
          image: require('../../asset/GPJ/2.jpg'),
          caption: "Cricket batting zone with target scoring system"
        },
        {
          id: 3,
          image: require('../../asset/GPJ/3.jpg'),
          caption: "Cricket batting zone with target scoring system"
        }
      ]
    },
    {
      id: 8,
      title: "Du Sharjah Entrepreneurship Festival 2025",
      slug: "du-sef",
      date: "2025",
      client: "Du",
      category: "AI Experience",
      tags: ["AI", "Entrepreneurship", "Interactive", "Innovation"],
      description: `
        The objective was to showcase du's innovation leadership by delivering engaging AI-powered experiences that merge technology, creativity, and interactivity, drawing entrepreneurial minds into immersive digital conversations aligned with the festival's future-forward ethos.<br/><br/>
        
        Key activations included an AI Chatbot with Avatar & Voice Interaction—a microphone-enabled kiosk featuring a modern, approachable AI avatar trained on du-specific and startup content, enabling visitors to engage in real-time, personalized Q&A about du's services and innovation. This activation generated strong attention and repeat engagement, reinforcing du's position at the forefront of telecom and AI technology.<br/><br/>
        
        The second activation was an AI Photo Booth with Theme Selection, allowing users to choose from multiple entrepreneurial-themed overlays and receive AI-enhanced, branded photos with options for digital sharing. This fun, creative experience was highly popular with younger audiences, encouraging social sharing and strengthening du's brand relevance in the startup ecosystem.
      `,
      videoThumbnail: require('../../asset/du SEF/1.jpeg'),
      mainImage: require('../../asset/du SEF/1.jpeg'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/du SEF/1.jpeg'),
          caption: "AI Chatbot"
        },
        {
          id: 2,
          image: require('../../asset/du SEF/2.jpeg'),
          caption: "AI Photo Booth"
        },
        {
          id: 3,
          image: require('../../asset/du SEF/3.jpeg'),
          caption: "AI Photo Booth"
        }
      ]
    },
    {
      id: 9,
      title: "Arab Media Summit 2024",
      slug: "arab-media-summit",
      date: "2024",
      client: "Arab Media Summit",
      category: "Media & Broadcasting",
      tags: ["Media", "Broadcasting", "Technology", "Innovation"],
      description: `
        To reflect the summit's future-focused theme on media and storytelling, the activation featured a cutting-edge AI Video Booth that transformed visitors into instant content creators.<br/><br/>
        
        Attendees recorded short clips, which were automatically enhanced using AI — with branded overlays, dynamic edits, subtitles, and voice modulation applied in real time. The experience demonstrated the power of AI in fast, intelligent media production, offering participants personalized, shareable videos within minutes.<br/><br/>
        
        Drawing in media professionals and creators alike, the activation positioned Codebrew and the Arab Media Summit as pioneers in AI-driven storytelling and next-gen content creation.
      `,
      videoThumbnail: require('../../asset/Arab Media/1.jpg'),
      mainImage: require('../../asset/Arab Media/1.jpg'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/Arab Media/1.jpg'),
          caption: "Media technology showcase and broadcasting demonstrations"
        },
        {
          id: 2,
          image: require('../../asset/Arab Media/2.jpg'),
          caption: "Interactive media displays and content creation stations"
        },
        {
          id: 3,
          image: require('../../asset/Arab Media/3.jpeg'),
          caption: "Live broadcasting demonstrations and industry networking"
        }
      ]
    },
    {
      id: 10,
      title: "Khazna Capacity 2025",
      slug: "khazana-capacity",
      date: "04–06 February 2025",
      client: "Khazana",
      category: "Interactive Kiosk",
      tags: ["Video Kiosk", "B2B", "Digital Infrastructure"],
      description: `
        The objective was to provide an intuitive and visually impactful way for event attendees to engage with Khazna's digital infrastructure offerings through an interactive video experience, delivering quick, informative content suitable for a high-traffic, B2B-focused environment.<br/><br/>
        
        The key activation was the Interactive Video Kiosk, a sleek, touch-enabled setup featuring two prominent buttons, each launching a branded video to showcase Khazna's key services. Customization included a dual-button interface labeled with topics like "Data Center Overview" and "Innovation & Future," a fully branded UI and kiosk enclosure, and high-resolution, optimized video playback.<br/><br/>
        
        Engagement was driven by the kiosk's tactile simplicity, allowing attendees to select content at their own pace and explore areas of interest. The outcome was a consistent and effective engagement point that sparked conversation and delivered complex messaging in a clear, modern, and self-guided visual format.
      `,
      videoThumbnail: require('../../asset/Khazana Capacity/1.jpeg'),
      mainImage: require('../../asset/Khazana Capacity/1.jpeg'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/Khazana Capacity/1.jpeg'),
          caption: "Services Showcasing Kiosk"
        },
        {
          id: 1,
          image: require('../../asset/Khazana Capacity/2.jpeg'),
          caption: "Services Showcasing Kiosk"
        },
        {
          id: 1,
          image: require('../../asset/Khazana Capacity/3.jpeg'),
          caption: "Services Showcasing Kiosk"
        },
        {
          id: 1,
          image: require('../../asset/Khazana Capacity/4.jpeg'),
          caption: "Services Showcasing Kiosk"
        }
      ]
    },
    {
      id: 11,
      title: "NBA Ramadan Majlis 2025",
      slug: "nba-ramadan-majlis",
      date: "Ramadan 2025",
      client: "NBA",
      category: "Sports & Cultural",
      tags: ["Sports", "Cultural", "Ramadan", "Community"],
      description: `The objective is to create engaging, culturally resonant, and brand-aligned interactive experiences that connect the spirit of basketball with the social and reflective essence of Ramadan, encouraging active participation and memorable moments. Key activations include the NBA Basketball Batak, a custom-branded, fast-paced, reaction-based light-up wall game inspired by traditional Batak machines and themed around basketball, and the Catch-the-Ball Activation, a fully customized, 360-degree dynamic ball-catching game designed to test agility and quick response.
      `,
      videoThumbnail: require('../../asset/NBA Ramadan Majlis/1.jpg'),
      mainImage: require('../../asset/NBA Ramadan Majlis/1.jpg'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/NBA Ramadan Majlis/1.jpg'),
          caption: "Basketball Batak"
        },
        {
          id: 2,
          image: require('../../asset/NBA Ramadan Majlis/2.jpg'),
          caption: "Catch-the-Ball Activation"
        },
        {
          id: 3,
          image: require('../../asset/NBA Ramadan Majlis/3.jpg'),
          caption: "Basketball Arcade Machine"
        },
        {
          id: 4,
          image: require('../../asset/NBA Ramadan Majlis/4.jpg'),
          caption: "Connect 4 Basketball"
        }
      ]
    },
    {
      id: 12,
      title: "Sharjah Reading Festival 2025",
      slug: "sharjah-festival",
      date: "01–04 May 2025",
      client: "Sharjah Reading Festival",
      category: "Educational Technology",
      tags: ["AI", "Education", "Hologram", "Learning"],
      description: `
        The objective was to spark curiosity and promote learning among students by merging technology with education through an AI-powered hologram experience, creating an engaging, futuristic interaction point that aligned with the Sharjah Reading Festival's mission to foster a love for reading, inquiry, and knowledge.<br/><br/>
        
        The key activation was the AI Hologram (Holofans) Chatbot, an interactive AI avatar displayed via holofans, designed to converse with students, answer questions, and encourage curiosity through an educational chatbot interface. Customization included a fully animated 3D avatar designed to be friendly and relatable for young audiences, an AI trained on educational topics, and visuals themed to the festival.<br/><br/>
        
        Engagement was high as students interacted verbally or via a simple interface, receiving real-time responses that mimicked a futuristic AI assistant. The outcome was a captivating experience for both students and educators, positioning technology as a fun and informative learning tool and making the interaction both memorable and impactful.
      `,
      videoThumbnail: require('../../asset/Sharjah Festival/1.jpeg'),
      videoUrl: "https://www.youtube.com/embed/y1I4oW47HZ0?si=9XllTIbzZIzuD9Ju",
      mainImage: require('../../asset/Sharjah Festival/1.jpeg'),
      gallery: [
        {
          id: 1,
          image: require('../../asset/Sharjah Festival/1.jpeg'),
          caption: "AI Chatbot Hologram"
        },
        {
          id: 2,
          image: require('../../asset/Sharjah Festival/2.jpeg'),
          caption: "AI Chatbot Hologram"
        },
        {
          id: 3,
          image: require('../../asset/Sharjah Festival/3.jpeg'),
          caption: "AI Chatbot Hologram"
        },
        {
          id: 4,
          image: require('../../asset/Sharjah Festival/4.jpeg'),
          caption: "AI Chatbot Hologram"
        }
      ]
    }
  ];

  // Find the project that matches the slug
  const project = projects.find(p => p.slug === slug);

  // Scroll to top when component mounts or slug changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  // Create many blobs positioned far above the screen
  useEffect(() => {
    console.log("Blob creation effect running");
    const pageDecoration = document.querySelector('.project-page-decoration');
    if (!pageDecoration) {
      console.error("Could not find .project-page-decoration element");
      return;
    }
    
    console.log("Found page decoration element:", pageDecoration);
    
    // Create a blob with specific vertical position and horizontal bias
    const createBlob = (verticalPosition, horizontalBias = null) => {
      const blob = document.createElement('div');
      blob.className = 'floating-blob';
      
      // Randomize horizontal position with optional bias
      let leftPosition;
      if (horizontalBias === 'far-left') {
        leftPosition = -5 + Math.random() * 15; // -5% to 10% (far left edge)
      } else if (horizontalBias === 'left') {
        leftPosition = 10 + Math.random() * 20; // 10% to 30% (left side)
      } else if (horizontalBias === 'center') {
        leftPosition = 30 + Math.random() * 40; // 30% to 70% (center)
      } else if (horizontalBias === 'right') {
        leftPosition = 70 + Math.random() * 20; // 70% to 90% (right side)
      } else if (horizontalBias === 'far-right') {
        leftPosition = 90 + Math.random() * 15; // 90% to 105% (far right edge)
      } else {
        leftPosition = 5 + Math.random() * 90; // 5% to 95% (full width)
      }
      
      blob.style.left = `${leftPosition}%`;
      
      // Set vertical position (negative to be above the viewport)
      blob.style.top = `${verticalPosition}px`;
      
      // Randomize size
      const size = 100 + Math.random() * 200; // Random size between 100px and 300px
      blob.style.width = `${size}px`;
      blob.style.height = `${size}px`;
      
      // Randomize opacity and color intensity
      const opacity = 0.25 + Math.random() * 0.15; // Between 0.25 and 0.4
      blob.style.background = `rgba(227, 41, 97, ${opacity})`;
      
      // Set parallax speed
      blob.dataset.speed = 0.2 + Math.random() * 0.2; // Random speed between 0.2 and 0.4
      
      return blob;
    };
    
    // Create blobs with better distribution
    const totalBlobs = 65;
    const blobs = [];
    
    // Position blobs from -15000px up to the top of the viewport
    // with even distribution across far-left, left, center, right, and far-right
    for (let i = 0; i < totalBlobs; i++) {
      const verticalPosition = -15000 + (i * (15000 / totalBlobs));
      
      // Determine horizontal bias based on position
      let horizontalBias;
      const position = i % 5;
      if (position === 0) horizontalBias = 'far-left';
      else if (position === 1) horizontalBias = 'left';
      else if (position === 2) horizontalBias = 'center';
      else if (position === 3) horizontalBias = 'right';
      else horizontalBias = 'far-right';
      
      const blob = createBlob(verticalPosition, horizontalBias);
      pageDecoration.appendChild(blob);
      blobs.push(blob);
    }
    
    // Add extra blobs near the top with explicit edge bias
    for (let i = 0; i < 15; i++) {
      // Cycle through all positions for the extra blobs
      const positions = ['far-left', 'left', 'center', 'right', 'far-right'];
      const horizontalBias = positions[i % 5];
      const verticalPosition = -500 - (i * 300); // Position between -500px and -4900px
      const blob = createBlob(verticalPosition, horizontalBias);
      pageDecoration.appendChild(blob);
      blobs.push(blob);
    }
    
    // Add specific blobs at the far left edges
    for (let i = 0; i < 5; i++) {
      const verticalPosition = -1000 - (i * 800); // Well-spaced vertical positions
      const blob = createBlob(verticalPosition, 'far-left');
      pageDecoration.appendChild(blob);
      blobs.push(blob);
    }
    
    console.log(`Created ${blobs.length} blobs`);
    
    // Handle scroll to move blobs with parallax effect
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      
      // Update all blobs position
      blobs.forEach((blob) => {
        const speed = parseFloat(blob.dataset.speed) || 0.3;
        const initialTop = parseInt(blob.style.top) || 0;
        
        // Apply parallax movement
        blob.style.transform = `translateY(${currentScrollY * speed}px)`;
        
        // Calculate actual position
        const blobTop = initialTop + (currentScrollY * speed);
        
        // Make blobs visible only when they're near or in the viewport
        if (blobTop < -viewportHeight || blobTop > viewportHeight * 2) {
          blob.style.opacity = '0';
        } else {
          // Fade in as they approach the viewport
          const distance = Math.abs(blobTop);
          const maxDistance = viewportHeight;
          // Opacity range: minimum 0.2, maximum 0.5
          const opacity = 0.2 + (0.3 * (1 - Math.min(distance / maxDistance, 1)));
          blob.style.opacity = opacity.toString();
        }
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Call once to set initial positions
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      // Clean up blobs
      blobs.forEach(blob => {
        if (pageDecoration.contains(blob)) {
          pageDecoration.removeChild(blob);
        }
      });
    };
  }, []);

  // Set up scroll animations
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    // Observe all elements with animate-element class
    document.querySelectorAll('.animate-element').forEach(el => {
      observer.observe(el);
    });
    
    return () => {
      observer.disconnect();
    };
  }, []);

  // Update the useEffect for the jQuery carousel
  useEffect(() => {
    if (!project || !project.gallery || project.gallery.length === 0) return;
    
    // Wait for DOM to be ready
    setTimeout(() => {
      const carousel = $('#carousel');
      const threshold = 100; // Reduced threshold for better mobile responsiveness
      let dragStart, dragEnd;
      let isDragging = false;
      
      // Function to calculate responsive slide width
      const getSlideWidth = () => {
        const windowWidth = $(window).width();
        if (windowWidth <= 576) {
          return windowWidth * 0.85; // 85% on mobile
        } else if (windowWidth <= 768) {
          return windowWidth * 0.75; // 75% on tablet
        } else if (windowWidth <= 992) {
          return windowWidth * 0.65; // 65% on small desktop
        } else if (windowWidth <= 1200) {
          return windowWidth * 0.55; // 55% on medium desktop
        } else {
          return windowWidth * 0.45; // 45% on large desktop
        }
      };
      
      // Function to get responsive margin
      const getSlideMargin = () => {
        return 30; // Consistent 30px gap between slides
      };
      
      // Function to initialize carousel positioning
      const initializeCarousel = () => {
        const windowWidth = $(window).width();
        const singleSlideWidth = getSlideWidth();
        const slideMargin = getSlideMargin();
        
        // Set slide widths and margins
        $('.slide').width(singleSlideWidth).css('margin-right', slideMargin + 'px');
        
        // Calculate the offset needed to center the first slide
        const centerOffset = (windowWidth - singleSlideWidth) / 2;
        
        // Position the carousel to center the first slide
        carousel.css('left', `-${singleSlideWidth + slideMargin - centerOffset}px`);
        
        // For better initial positioning, move the last slide to the beginning
        if ($('.slide:first').length && $('.slide:last').length) {
          $('.slide:first').before($('.slide:last'));
        }
      };
      
      // Initialize carousel
      initializeCarousel();
      
      // Mouse events for desktop
      carousel.on('mousedown', function(event){
        if (carousel.hasClass('transition')) return;
        isDragging = true;
        dragStart = event.pageX;
        $(this).on('mousemove', function(event){
          if (!isDragging) return;
          dragEnd = event.pageX;
          $(this).css('transform','translateX('+ dragPos() +'px)');
        });
        $(document).on('mouseup', function(){
          isDragging = false;
          if (Math.abs(dragPos()) > threshold) {
            if (dragPos() > 0) {
              return shiftSlide(1);
            } else {
              return shiftSlide(-1);
            }
          }
          shiftSlide(0);
        });
      });
      
      // Touch events for mobile
      carousel.on('touchstart', function(event){
        if (carousel.hasClass('transition')) return;
        isDragging = true;
        dragStart = event.originalEvent.touches[0].pageX;
        $(this).on('touchmove', function(event){
          if (!isDragging) return;
          event.preventDefault(); // Prevent scrolling
          dragEnd = event.originalEvent.touches[0].pageX;
          $(this).css('transform','translateX('+ dragPos() +'px)');
        });
        $(document).on('touchend', function(){
          isDragging = false;
          if (Math.abs(dragPos()) > threshold) {
            if (dragPos() > 0) {
              return shiftSlide(1);
            } else {
              return shiftSlide(-1);
            }
          }
          shiftSlide(0);
        });
      });
      
      function dragPos() {
        return dragEnd - dragStart;
      }
      
      function shiftSlide(direction) {
        if (carousel.hasClass('transition')) return;
        dragEnd = dragStart;
        $(document).off('mouseup touchend');
        carousel.off('mousemove touchmove')
                .addClass('transition')
                .css('transform','translateX(' + (direction * (getSlideWidth() + getSlideMargin() * 2)) + 'px)'); 
        setTimeout(function(){
          if (direction === 1) {
            $('.slide:first').before($('.slide:last'));
          } else if (direction === -1) {
            $('.slide:last').after($('.slide:first'));
          }
          carousel.removeClass('transition')
          carousel.css('transform','translateX(0px)'); 
        }, 700);
      }
      
      // Handle window resize
      let resizeTimeout;
      $(window).on('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          initializeCarousel();
        }, 250); // Debounce resize events
      });
      
      // Prevent context menu on long press (mobile)
      carousel.on('contextmenu', function(e) {
        e.preventDefault();
      });
      
    }, 500); // Small delay to ensure DOM is ready
    
    // Cleanup
    return () => {
      $('#carousel').off('mousedown mousemove touchstart touchmove');
      $(document).off('mouseup touchend');
      $(window).off('resize');
    };
  }, [project]);

  // Helper function to check if URL is YouTube
  const isYouTubeUrl = (url) => {
    if (!url) return false;
    return url.includes('youtube.com') || url.includes('youtu.be') || url.includes('youtube.com/embed');
  };

  // Helper function to extract YouTube video ID and create proper embed URL
  const getYouTubeEmbedUrl = (url) => {
    if (!url) return '';
    
    let videoId = '';
    
    // Extract video ID from various YouTube URL formats
    if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('v=')[1]?.split('&')[0];
    } else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1]?.split('?')[0];
    } else if (url.includes('youtube.com/embed/')) {
      videoId = url.split('embed/')[1]?.split('?')[0];
    }
    
    if (videoId) {
      // Create embed URL with aggressive autoplay parameters
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&rel=0&modestbranding=1&showinfo=0&controls=1&fs=1&cc_load_policy=0&iv_load_policy=3&autohide=0`;
    }
    
    // If it's already an embed URL, enhance it with autoplay
    if (url.includes('youtube.com/embed/')) {
      const baseUrl = url.split('?')[0];
      videoId = baseUrl.split('embed/')[1];
      return `${baseUrl}?autoplay=1&mute=1&rel=0&modestbranding=1&showinfo=0&controls=1&fs=1&cc_load_policy=0&iv_load_policy=3&autohide=0`;
    }
    
    return url; // Return original URL if we can't parse it
  };

  // Toggle video playback
  const toggleVideo = () => {
    setIsVideoPlaying(!isVideoPlaying);
  };
  
  // Handle video end or pause
  const handleVideoPause = () => {
    setIsVideoPlaying(false);
  };

  // Handle YouTube iframe click to unmute
  const handleYouTubeClick = (e) => {
    // For YouTube videos, we'll update the src to unmute after first click
    if (e.target.tagName === 'IFRAME' && isYouTubeUrl(project.videoUrl)) {
      const currentSrc = e.target.src;
      if (currentSrc.includes('mute=1')) {
        const newSrc = currentSrc.replace('mute=1', 'mute=0');
        e.target.src = newSrc;
      }
    }
  };

  // Handle case when project is not found
  if (!project) {
    return (
      <div className="project-details-page">
        <Navbar />
        <div className="content-container">
          <div className="project-not-found">
            <h1>Project Not Found</h1>
            <p>Sorry, the project you're looking for doesn't exist.</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  // Animation variants
  const slideVariants = {
    enterRight: {
      x: "100%",
      opacity: 0
    },
    enterLeft: {
      x: "-100%",
      opacity: 0
    },
    center: {
      x: 0,
      opacity: 1,
      zIndex: 1
    },
    exitLeft: {
      x: "-100%",
      opacity: 0,
      zIndex: 0
    },
    exitRight: {
      x: "100%",
      opacity: 0,
      zIndex: 0
    }
  };

  return (
    <div className="project-details-page">
      <ParticlesBackground />
      
      {/* Container for dynamically created blobs */}
      <div className="project-page-decoration" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        minHeight: '100vh',
        minHeight: '100dvh', // Use dvh for better mobile support
        pointerEvents: 'none',
        zIndex: 1,
        overflow: 'hidden'
      }}></div>
      
      {/* Navbar */}
      <div className="navbar-wrapper">
        <Navbar />
      </div>
      
      <div className="content-container">
        {/* Project Title and Details */}
        <div className="project-header-info">
          <div className="project-title-container animate-element">
            <h1 className="project-title">{project.title}</h1>
          </div>
          
          <div className="project-meta" ref={infoRef}>
            <div className="meta-item animate-element">
              <span className="meta-label">Date</span>
              <span className="meta-value">{project.date}</span>
            </div>
            
            <div className="meta-item animate-element">
              <span className="meta-label">Client</span>
              <span className="meta-value">{project.client}</span>
            </div>
            
            <div className="meta-item animate-element">
              <span className="meta-label">Category</span>
              <span className="meta-value">{project.category}</span>
            </div>
            
            <div className="project-tags">
              {project.tags.map((tag, index) => (
                <span key={index} className="project-tag animate-element">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
        
        {/* Project Description - Now in a two-column layout */}
        <div className="project-description-container" ref={descriptionRef}>
          <div className="project-overview-layout">
            <div className="project-description animate-element">
              <h2 className="section-title">
                Project Overview
                <span className="title-underline"></span>
              </h2>
              {project.description.split('\n\n').map((paragraph, index) => (
                <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }}></p>
              ))}
            </div>
            
            <div className="project-video-container animate-element">
              {project.videoUrl ? (
                // Show video functionality when video URL exists
                isVideoPlaying ? (
                  <div className="video-player">
                    {isYouTubeUrl(project.videoUrl) ? (
                      // Render YouTube video as iframe
                      <div className="youtube-container" onClick={handleYouTubeClick}>
                        <iframe
                          className="project-video youtube-video"
                          src={getYouTubeEmbedUrl(project.videoUrl)}
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                          loading="eager"
                        ></iframe>
                      </div>
                    ) : (
                      // Render regular video files
                      <video 
                        ref={videoRef}
                        controls 
                        autoPlay 
                        className="project-video"
                        src={project.videoUrl}
                        onPause={handleVideoPause}
                        onEnded={handleVideoPause}
                      >
                        Your browser does not support the video tag.
                      </video>
                    )}
                    <button className="close-video-btn" onClick={toggleVideo}>
                      &times;
                    </button>
                  </div>
                ) : (
                  <div className="video-thumbnail-container" onClick={toggleVideo}>
                    <img 
                      src={project.videoThumbnail} 
                      alt="Video thumbnail" 
                      className="video-thumbnail" 
                    />
                    <div className="play-button-overlay">
                      <div className="play-button">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 5.14v14l11-7-11-7z" fill="currentColor" />
                        </svg>
                      </div>
                    </div>
                  </div>
                )
              ) : (
                // Show just image when no video URL exists
                <div className="static-image-container">
                  <img 
                    src={project.videoThumbnail} 
                    alt="Project image" 
                    className="video-thumbnail" 
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        
        {/* Project Gallery - Conditional Layout */}
        <div className="gallery-section">
          <h2 className="section-title animate-element">
            Project Gallery
            <span className="title-underline"></span>
          </h2>
          
          {project.gallery.length <= 2 ? (
            // Simple centered layout for 1-2 images
            <div className="simple-gallery">
              {project.gallery.map((item, index) => (
                <div 
                  key={index} 
                  className="simple-gallery-item"
                  onClick={() => setSelectedImage(item.image)}
                >
                  <img src={item.image} alt={item.caption} className="simple-gallery-image" />
                  <div className="simple-gallery-caption">{item.caption}</div>
                </div>
              ))}
            </div>
          ) : (
            // Carousel for 3+ images
            <div className="wrap">
              <div className="window">
                <div id="carousel">
                  {project.gallery.map((item, index) => (
                    <div 
                      key={index} 
                      className="slide" 
                      id={`b${index + 1}`}
                      onClick={() => setSelectedImage(item.image)}
                    >
                      <img src={item.image} alt={item.caption} className="slide-image" />
                      <div className="slide-caption">{item.caption}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
        
        {/* Project Navigation */}
        <div className="project-navigation">
          <div className="nav-button-container">
            {(() => {
              const currentIndex = projects.findIndex(p => p.slug === slug);
              const prevIndex = currentIndex > 0 ? currentIndex - 1 : projects.length - 1;
              const nextIndex = currentIndex < projects.length - 1 ? currentIndex + 1 : 0;
              const prevProject = projects[prevIndex];
              const nextProject = projects[nextIndex];
              
              return (
                <>
                  {/* Previous Project */}
                  <div className="nav-button prev-project animate-element">
                    <a href={`/project/${prevProject.slug}`} className="nav-link">
                      <div className="nav-arrow">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <div className="nav-content">
                        <span className="nav-label">Previous Project</span>
                        <span className="nav-title">{prevProject.title}</span>
                      </div>
                    </a>
                  </div>
                  
                  {/* Next Project */}
                  <div className="nav-button next-project animate-element">
                    <a href={`/project/${nextProject.slug}`} className="nav-link">
                      <div className="nav-content">
                        <span className="nav-label">Next Project</span>
                        <span className="nav-title">{nextProject.title}</span>
                      </div>
                      <div className="nav-arrow">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </a>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      </div>
      
      {/* Image Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <button className="lightbox-close" onClick={() => setSelectedImage(null)}>&times;</button>
          <img src={selectedImage} alt="Project gallery" className="lightbox-image" />
        </div>
      )}
      
      <style>
        {`
          .floating-blob {
            position: absolute;
            border-radius: 50%;
            filter: blur(15px);
            box-shadow: 0 0 25px rgba(227, 41, 97, 0.5);
            will-change: transform, opacity;
            transition: opacity 0.5s ease;
          }
          
          /* Make sure content is above the blobs */
          .content-container {
            position: relative;
            z-index: 2;
            margin-top: 12rem; /* Added top margin */
          }
          
          /* Ensure particles background covers full screen on all devices */
          .particle-background-container {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            min-height: 100vh !important;
            min-height: 100dvh !important; /* Better mobile support */
            min-height: -webkit-fill-available !important; /* Safari/Mac fix */
            z-index: 0 !important;
            pointer-events: none !important;
          }
          
          /* Project header info section */
          .project-header-info {
            margin-bottom: 3rem;
          }
          
          .project-title-container {
            text-align: center;
            margin-bottom: 1.5rem;
          }
          
          .project-title {
            font-size: 2.5rem;
            font-weight: 700;
            color: #fff;
            margin: 0;
          }
          
          /* Project meta information */
          .project-meta {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 2rem;
            padding: 1.5rem;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 8px;
            backdrop-filter: blur(10px);
          }
          
          .meta-item {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          
          .meta-label {
            font-size: 0.9rem;
            color: #e3295f;
            margin-bottom: 0.5rem;
            font-weight: 600;
            text-transform: uppercase;
          }
          
          .meta-value {
            font-size: 1.1rem;
            font-weight: 500;
          }
          
          /* Project tags */
          .project-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 0.75rem;
            justify-content: center;
          }
          
          .project-tag {
            background: rgba(227, 41, 97, 0.15);
            color: #e3295f;
            padding: 0.5rem 1rem;
            border-radius: 50px;
            font-size: 0.9rem;
            font-weight: 500;
            transition: all 0.3s ease;
          }
          
          .project-tag:hover {
            background: rgba(227, 41, 97, 0.25);
            transform: translateY(-2px);
          }
          
          /* Fix gallery hover caption */
          .gallery-item {
            position: relative;
            overflow: hidden;
            cursor: pointer;
          }
          
          .gallery-image-container {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
          }
          
          .gallery-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
          }
          
          .gallery-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            opacity: 0;
            transition: opacity 0.3s ease;
            padding: 1rem;
            box-sizing: border-box;
          }
          
          .gallery-item:hover .gallery-overlay {
            opacity: 1;
          }
          
          /* Simple Gallery Styles for 1-2 images */
          .simple-gallery {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 2rem;
            flex-wrap: wrap;
            padding: 2rem 0;
          }
          
          .simple-gallery-item {
            max-width: 500px;
            width: 100%;
            cursor: pointer;
            transition: transform 0.3s ease;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 12px;
            overflow: hidden;
            backdrop-filter: blur(10px);
          }
          
          .simple-gallery-item:hover {
            transform: translateY(-5px);
          }
          
          .simple-gallery-image {
            width: 100%;
            height: 300px;
            object-fit: cover;
            display: block;
          }
          
          .simple-gallery-caption {
            padding: 1rem;
            text-align: center;
            color: #fff;
            font-size: 0.95rem;
            line-height: 1.4;
          }
          
          /* Responsive adjustments for simple gallery */
          @media (max-width: 768px) {
            .simple-gallery {
              gap: 1.5rem;
              padding: 1.5rem 1rem;
            }
            
            .simple-gallery-item {
              max-width: 100%;
            }
            
            .simple-gallery-image {
              height: 250px;
            }
                     }
            
            .gallery-item:hover .gallery-image {
            transform: scale(1.05);
          }
          
          .gallery-caption {
            color: white;
            text-align: center;
            margin-bottom: 1rem;
            font-size: 1rem;
            max-width: 100%;
            overflow: hidden;
          }
          
          .gallery-zoom-icon {
            color: white;
            width: 2rem;
            height: 2rem;
          }
          
          /* Enhanced styling for bold headings and text */
          .project-description b {
            font-weight: 900;
            font-family: 'Termina Black', sans-serif;
            color: white;
            display: inline;
            margin-top: 0;
            margin-bottom: 0;
          }
          
          /* Set Montserrat for body text */
          .project-description {
            height: auto; /* Allow height to adjust to content */
            overflow: visible; /* Remove scrolling */
            max-height: none; /* Remove any max-height limitation */
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          
          /* Improve paragraph spacing and readability */
          .project-description p {
            margin-bottom: 1.2em;
            line-height: 1.6;
            font-size: 0.95rem;
          }
          
          /* Style for paragraphs that start with bold text (section headers) */
          .project-description p b:first-child {
            display: inline;
            margin-bottom: 0;
            font-weight: 900;
            font-family: 'Termina Black', sans-serif;
          }
          
          /* Project description container - adjust to content */
          .project-description-container {
            height: auto;
            overflow: visible;
            margin-bottom: 2rem;
          }
          
          /* Project overview two-column layout */
          .project-overview-layout {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 2rem;
            margin-top: 1.5rem;
            align-items: center; /* Vertically center align both columns */
          }
          
          /* Video container styling */
          .project-video-container {
            position: relative;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
            height: auto; /* Changed from 100% to auto */
            aspect-ratio: 16/9;
            background: #000;
            align-self: center; /* Center align within the grid cell */
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .video-thumbnail-container {
            position: relative;
            width: 100%;
            height: 100%;
            cursor: pointer;
            overflow: hidden;
          }
          
          .video-thumbnail {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
          }
          
          .video-thumbnail-container:hover .video-thumbnail {
            transform: scale(1.05);
          }
          
          .play-button-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.3);
            transition: background 0.3s ease;
          }
          
          .video-thumbnail-container:hover .play-button-overlay {
            background: rgba(0, 0, 0, 0.5);
          }
          
          .play-button {
            width: 80px;
            height: 80px;
            background: rgba(227, 41, 97, 0.8);
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            transition: transform 0.3s ease, background 0.3s ease;
          }
          
          .play-button svg {
            width: 40px;
            height: 40px;
            margin-left: 5px; /* Adjust for the play icon's visual center */
          }
          
          .video-thumbnail-container:hover .play-button {
            transform: scale(1.1);
            background: rgba(227, 41, 97, 1);
          }
          
          .video-player {
            position: relative;
            width: 100%;
            height: 100%;
          }
          
          .project-video {
            width: 100%;
            height: 100%;
            object-fit: contain; /* Changed from cover to contain to prevent cropping */
          }
          
          .youtube-container {
            width: 100%;
            height: 100%;
            position: relative;
          }
          
          .youtube-video {
            border: none;
            border-radius: 8px;
            width: 100%;
            height: 100%;
          }
          
          .close-video-btn {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 30px;
            height: 30px;
            background: rgba(0, 0, 0, 0.7);
            border: none;
            border-radius: 50%;
            color: white;
            font-size: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            transition: background 0.3s ease;
            z-index: 10;
          }
          
          .close-video-btn:hover {
            background: rgba(227, 41, 97, 0.9);
          }
          
          /* Static image container for when there's no video */
          .static-image-container {
            width: 100%;
            height: 100%;
            overflow: hidden;
          }
          
          .static-image-container .video-thumbnail {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
          }
          
          .static-image-container:hover .video-thumbnail {
            transform: scale(1.02);
          }
          
          /* Responsive adjustments */
          @media (max-width: 992px) {
            .project-overview-layout {
              grid-template-columns: 1fr;
            }
            
            .project-video-container {
              aspect-ratio: 16/9; /* Maintain aspect ratio on mobile */
              height: auto; /* Let height be determined by aspect ratio */
              margin-top: 1.5rem;
            }
          }
          
          /* Full Width Infinite Carousel Styles with Peek Effect */
          .gallery-section {
            margin: 3rem 0;
            width: 100%;
            padding: 0; /* Remove any padding */
          }
          
          .wrap {
            position: relative;
            width: 100vw; /* Full viewport width */
            height: 700px; /* Increased from 600px */
            margin: 0 auto;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
            overflow: visible;
            left: 50%;
            right: 50%;
            margin-left: -50vw;
            margin-right: -50vw;
            touch-action: pan-y; /* Allow vertical scrolling but handle horizontal touch events */
          }
          
          .window {
            overflow: hidden;
            position: relative;
            background: transparent;
            width: 100%;
            height: 100%;
          }
          
          #carousel {
            width: 10000px;
            position: relative;
            top: 0;
            /* left value will be set by JavaScript */
            height: 100%;
            user-select: none; /* Prevent text selection during drag */
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
          }
          
          .slide {
            height: 700px; /* Increased from 600px */
            /* width will be set by JavaScript */
            cursor: pointer;
            float: left;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: relative;
            overflow: hidden;
            /* margin will be set by JavaScript based on screen size */
            border-radius: 12px; /* Increased border radius for modern look */
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
          }
          
          .slide:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
          }
          
          .slide-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top: 0;
            left: 0;
            transition: transform 0.3s ease;
          }
          
          .slide:hover .slide-image {
            transform: scale(1.02);
          }
          
          .slide-caption {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.7), transparent);
            color: white;
            padding: 20px 15px 15px 15px;
            font-size: 16px;
            text-align: center;
            font-weight: 500;
            line-height: 1.4;
          }
          
          /* Active slide styling */
          .slide.active {
            box-shadow: 0 0 30px rgba(227, 41, 97, 0.5);
            z-index: 2;
          }
          
          /* Smooth transitions */
          .transition {
            transition: 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          }
          
          /* Responsive adjustments with improved breakpoints */
          @media (max-width: 1400px) {
            .wrap {
              height: 650px;
            }
            
            .slide {
              height: 650px;
            }
          }
          
          @media (max-width: 1200px) {
            .wrap {
              height: 600px;
            }
            
            .slide {
              height: 600px;
            }
            
            .slide-caption {
              font-size: 15px;
              padding: 18px 12px 12px 12px;
            }
          }
          
          @media (max-width: 992px) {
            .wrap {
              height: 550px;
            }
            
            .slide {
              height: 550px;
              border-radius: 10px;
            }
            
            .slide-caption {
              font-size: 14px;
              padding: 15px 10px 10px 10px;
            }
          }
          
          @media (max-width: 768px) {
            .wrap {
              height: 500px;
            }
            
            .slide {
              height: 500px;
              border-radius: 8px;
            }
            
            .slide-caption {
              font-size: 14px;
              padding: 15px 10px 10px 10px;
            }
            
            /* Reduce hover effects on touch devices */
            .slide:hover {
              transform: none;
            }
            
            .slide:hover .slide-image {
              transform: none;
            }
          }
          
          @media (max-width: 576px) {
            .gallery-section {
              margin: 2rem 0;
            }
            
            .wrap {
              height: 450px;
            }
            
            .slide {
              height: 450px;
              border-radius: 6px;
            }
            
            .slide-caption {
              font-size: 13px;
              padding: 12px 8px 8px 8px;
              line-height: 1.3;
            }
          }
          
          @media (max-width: 480px) {
            .wrap {
              height: 400px;
            }
            
            .slide {
              height: 400px;
            }
            
            .slide-caption {
              font-size: 12px;
              padding: 10px 6px 6px 6px;
            }
          }
          
          /* Touch feedback for mobile */
          @media (hover: none) and (pointer: coarse) {
            .slide {
              -webkit-tap-highlight-color: rgba(227, 41, 97, 0.1);
            }
            
            .slide:active {
              transform: scale(0.98);
              transition: transform 0.1s ease;
            }
          }
          
          /* Mobile-specific fixes for particle background */
          @media screen and (max-width: 768px) {
            .project-details-page {
              min-height: 100vh;
              min-height: 100dvh; /* Dynamic viewport height for mobile */
              min-height: -webkit-fill-available; /* Safari fallback */
            }
            
            .particle-background-container,
            .project-page-decoration {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100vw !important;
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: 100dvh !important;
              min-height: -webkit-fill-available !important;
              max-height: none !important;
              z-index: 0 !important;
            }
            
            /* Ensure tsparticles canvas covers full screen */
            #tsparticles {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100vw !important;
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: 100dvh !important;
              min-height: -webkit-fill-available !important;
            }
          }
          
          /* Mac/Safari specific fixes for full viewport coverage */
          @media screen and (-webkit-min-device-pixel-ratio: 1) {
            .particle-background-container,
            .project-page-decoration {
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: -webkit-fill-available !important;
            }
            
            #tsparticles {
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: -webkit-fill-available !important;
            }
          }
          
          /* Additional Safari-specific fix */
          @supports (-webkit-appearance: none) and (not (contain: paint)) {
            .particle-background-container,
            .project-page-decoration,
            #tsparticles {
              height: calc(100vh + 1px) !important;
              min-height: calc(100vh + 1px) !important;
            }
          }
          
          /* Project Navigation Styles */
          .project-navigation {
            margin: 4rem 0 2rem 0;
            padding: 0 1rem;
          }
          
          .nav-button-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 2rem;
            max-width: 1200px;
            margin: 0 auto;
          }
          
          .nav-button {
            flex: 1;
            max-width: 400px;
          }
          
          .nav-link {
            display: flex;
            align-items: center;
            padding: 1.5rem;
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(227, 41, 97, 0.2);
            border-radius: 12px;
            text-decoration: none;
            color: white;
            transition: all 0.3s ease;
            backdrop-filter: blur(10px);
            position: relative;
            overflow: hidden;
          }
          
          .nav-link::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(227, 41, 97, 0.1), transparent);
            transition: left 0.5s;
          }
          
          .nav-link:hover::before {
            left: 100%;
          }
          
          .nav-link:hover {
            background: rgba(227, 41, 97, 0.1);
            border-color: rgba(227, 41, 97, 0.4);
            transform: translateY(-2px);
            box-shadow: 0 10px 25px rgba(227, 41, 97, 0.2);
          }
          
          .prev-project .nav-link {
            justify-content: flex-start;
          }
          
          .next-project .nav-link {
            justify-content: flex-end;
            flex-direction: row-reverse;
          }
          
          .nav-arrow {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: rgba(227, 41, 97, 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 1rem;
            transition: all 0.3s ease;
          }
          
          .nav-arrow svg {
            width: 20px;
            height: 20px;
            color: #e3295f;
            transition: transform 0.3s ease;
          }
          
          .nav-link:hover .nav-arrow {
            background: rgba(227, 41, 97, 0.4);
            transform: scale(1.1);
          }
          
          .prev-project .nav-link:hover .nav-arrow svg {
            transform: translateX(-2px);
          }
          
          .next-project .nav-link:hover .nav-arrow svg {
            transform: translateX(2px);
          }
          
          .nav-content {
            display: flex;
            flex-direction: column;
            flex: 1;
            min-width: 0; /* Allow text truncation */
          }
          
          .prev-project .nav-content {
            text-align: left;
          }
          
          .next-project .nav-content {
            text-align: right;
          }
          
          .nav-label {
            font-size: 0.85rem;
            color: #e3295f;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 0.25rem;
          }
          
          .nav-title {
            font-size: 1.1rem;
            font-weight: 700;
            color: white;
            line-height: 1.3;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          
          /* Responsive adjustments for navigation */
          @media (max-width: 768px) {
            .project-navigation {
              margin: 3rem 0 1.5rem 0;
            }
            
            .nav-button-container {
              flex-direction: column;
              gap: 1.5rem;
            }
            
            .nav-button {
              width: 100%;
              max-width: none;
            }
            
            .nav-link {
              padding: 1.25rem;
              justify-content: flex-start !important;
              flex-direction: row !important;
            }
            
            .nav-content {
              text-align: left !important;
            }
            
            .nav-arrow {
              margin: 0 1rem 0 0;
            }
            
            .next-project .nav-arrow {
              order: 2;
              margin: 0 0 0 1rem;
            }
            
            .nav-title {
              font-size: 1rem;
              -webkit-line-clamp: 3;
            }
          }
          
          @media (max-width: 480px) {
            .nav-link {
              padding: 1rem;
            }
            
            .nav-arrow {
              width: 35px;
              height: 35px;
              margin: 0 0.75rem 0 0;
            }
            
            .nav-arrow svg {
              width: 16px;
              height: 16px;
            }
            
            .next-project .nav-arrow {
              margin: 0 0 0 0.75rem;
            }
            
            .nav-title {
              font-size: 0.95rem;
            }
            
            .nav-label {
              font-size: 0.8rem;
            }
          }
        `}
      </style>
      
      <Footer />
    </div>
  );
};

export default ProjectDetailsPage; 
